import PropTypes from "prop-types";
import BaseComponent from "../../../../../lib/components/BaseComponent";
import Window from "../../../../../lib/components/window/Window";
import VerticalLayout from "../../../../../lib/components/layouts/VerticalLayout";
import HorizontalLayout from "../../../../../lib/components/layouts/HorizontalLayout";

import React, {createRef} from "react";
import Button from "../../buttons/Button";

import ConfirmationDialog from "../../../../../lib/components/dialogs/ConfirmationDialog";
import SelectableDragList from "../../../../../lib/components/selectableDragList/SelectableDragList";
import DataType from "../../../../../lib/model/types/DataType";
import SelectableItem from "../../../../../lib/components/selectableDragList/SelectableItem";
import shortid from "shortid";
import FieldName from "../../../../../lib/model/query/FieldName";

class EntityExport extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      alertDialogOpen: false, selectedFieldsList: null
    }
    this.entityDef = this.props.dataSource.getEntityDef();
    this.selectableDragListRef = createRef();
  }

  componentDidMount() {
    super.componentDidMount();
    this.selectableDragListRef.current.setDefaultSelectedTargets();
    this.state.selectedFieldsList = this.selectableDragListRef.current.getData();
  }

  doDownload() {
    let selectedFields = this.state.selectedFieldsList;
    if (selectedFields) {
      let query = this.props.dataSource.getLastQuery();
      query.setSelectFields(selectedFields);
      query.setStartRow(-1);
      query.setEndRow(-1);
      this.props.dataSource.export(query, undefined);
    } else {
      this.setState({alertDialogOpen: true});
    }
  }

  buildFieldName(fieldName, relationName) {
    let fieldNameObj = new FieldName(fieldName, relationName);
    return fieldNameObj.getFullFieldName();
  }

  render() {

    let fieldElements = [];
    for (let index in this.entityDef.fieldsDef) {
      let fieldDef = this.entityDef.fieldsDef[index];
      if (fieldDef.type.type !== DataType.DATA_EXT && fieldDef.type.type !== DataType.OBJECT) {
        fieldElements.push(<SelectableItem
          active={true}
          elementId={this.buildFieldName(fieldDef.name, this.entityDef.baseDef.name)}
          key={shortid()}>
          {fieldDef.description}
        </SelectableItem>);
      }
    }

    return <>
      <Window title='Excelliste exportieren'>
        <VerticalLayout className='gap-4'>
          <SelectableDragList
            ref={this.selectableDragListRef}
            onChange={(list) => this.state.selectedFieldsList = list}>
            {fieldElements}
          </SelectableDragList>
          <HorizontalLayout className='justify-end'>
            <Button onClick={(e) => this.doDownload(e)}>Exportieren</Button>
          </HorizontalLayout>
        </VerticalLayout>
      </Window>
      {/* Alert dialog should there be a problem */}
      <ConfirmationDialog
        onConfirmClick={(e) => this.setState({alertDialogOpen: false})}
        title='Fehler beim Export'
        isOpen={this.state.alertDialogOpen}
        confirmButtonColor='error'
        showCancelButton={false}
        confirmButtonText='Schliessen'>
        Es sind keine Felder ausgewählt, bitte zuerst Felder auswählen!
      </ConfirmationDialog>
    </>;
  }
}

EntityExport.propTypes = {
  dataSource: PropTypes.object
}
export default EntityExport;
